// Consulter la section politique
import React from 'react';
import PresseList from '../presseView/PresseList';

const PolitiqueConsulter = () => {
  return (
    <div className="presse-page">
      <PresseList />
    </div>
  );
};

export default PolitiqueConsulter;
